import { useCallback } from 'react';
import { Button } from 'rsuite';
import { useElasticidadeCruzadaStore } from '../../ElasticidadeCruzada.store';
import styles from './styles.module.scss';

export const FilterActions = () => {
  const { reset } = useElasticidadeCruzadaStore();

  const handleClearFilters = useCallback(() => {
    reset();
  }, [reset]);

  return (
    <div className={styles.actionsWrapper}>
      <div className={styles.topActions}>
        <Button className={styles.btnClearFilter} onClick={handleClearFilters}>
          Limpar filtros
        </Button>
      </div>
      <div className={styles.savedFiltersWrapper} />
    </div>
  );
};
